/*=========================================================================================
  File Name: toast.js
  Description: Shared options for vue-toastification.

               WCAG 2.2 SC 2.2.1 Timing Adjustable (audit 29.1, 29.2). The app previously
               dismissed every toast after `toast_timeout_seconds` (6s by default), so a
               message could disappear before it had been read - and an error message that
               vanishes leaves the user with no idea what went wrong.

               me2's recommendation: "Ensure the message remains on the screen until
               dismissed by the user." That applies to every toast, so none of them carry a
               timeout now; the global options in main.js give each one a labelled dismiss
               button.
==========================================================================================*/

/**
 * Options for a confirmation message. Stays until the user dismisses it.
 */
const ACCESSIBILITY = { toastRole: 'alert', closeButtonLabel: 'Close message' };

export function successToast(extra = {}) {
  return { timeout: false, accessibility: ACCESSIBILITY, ...extra };
}

/**
 * Options for an error. `timeout: false` keeps it on screen until the user dismisses it.
 */
export function errorToast(extra = {}) {
  return { timeout: false, accessibility: ACCESSIBILITY, ...extra };
}
